module.exports = __webpack_public_path__ + "static/media/vignette_02.c120cc5d.png";